import { useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { $journalApi } from "@/entities/journal/fetch/fetch-client";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";

export const useSendSignMulti = (
  sectionOneId: string,
  search?: string,
  handleClose?: () => void,
) => {
  const queryClient = useQueryClient();

  const { mutate: sendMany } = $journalApi.useMutation(
    "post",
    "/api/v1/journals/section-one/{sectionOneListId}/items/sendToSignItems",
    {
      onSuccess: (data) => {
        const isPartial = data?.errorsList?.errors?.length || 0;
        notification.success({
          message: isPartial
            ? NOTIFICATION_MESSAGES.ENTRY_PARTIAL_SENT_TO_SIGNING // "Частично отправлено на подписание"
            : NOTIFICATION_MESSAGES.ENTRY_BULK_SENT_TO_SIGNING, // "Успешно отправлено на подписание"
        });

        queryClient.invalidateQueries({
          queryKey: journalsQueries.getSection1({
            sectionOneId,
            search,
          }).queryKey,
        });
        queryClient.invalidateQueries({
          queryKey:
            journalsQueries.getSectionOneSignersList(sectionOneId).queryKey,
        });
        handleClose?.();
      },
      onError: () => {
        notification.error({
          message: NOTIFICATION_MESSAGES.ENTRY_BULK_SEND_TO_SIGNING_ERROR, // "Ошибка при массовой отправке на подписание"
        });
      },
    },
  );

  return { sendMany };
};
